"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollBarWidth = exports.windowSize = void 0;

var windowSize = function () {
  if (!document || !window) return null;
  var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
  return {
    width: w,
    height: h
  };
};

exports.windowSize = windowSize;

var scrollBarWidth = function () {
  var div = document.createElement('div');
  div.style.height = '100px';
  div.style.overflow = 'scroll';
  div.style.position = 'absolute';
  div.style.top = '-9999px';
  div.style.width = '100px';
  document.body.appendChild(div);
  var width = div.offsetWidth - div.clientWidth;
  document.body.removeChild(div);
  return width;
};

exports.scrollBarWidth = scrollBarWidth;